// /home/w3d/web3reg-com/src/pages/NotFound.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGhost, faHome, faSearch, faGlobe, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Footer from '../components/Footer';
import GlobalNav from '../components/GlobalNav';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <GlobalNav />
      
      <section className="hero" style={{ 
        padding: '6rem 2rem 4rem 2rem',
        textAlign: 'center',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          {/* 404 Number with Glow Effect */}
          <div style={{ 
            fontSize: '12rem', 
            fontWeight: 'bold', 
            color: 'var(--gold)', 
            textShadow: '0 0 30px var(--gold-shadow)',
            marginBottom: '-2rem',
            lineHeight: '1'
          }}>
            404
          </div>
          
          {/* Ghost Icon */}
          <div style={{ 
            fontSize: '8rem', 
            color: 'var(--text-secondary)', 
            marginBottom: '1rem',
            opacity: '0.7',
            animation: 'float 3s ease-in-out infinite'
          }}>
            <FontAwesomeIcon icon={faGhost} />
          </div>

          <h1 style={{ fontSize: '3rem', color: 'var(--text-light)', marginBottom: '1.5rem' }}>
            Page Not Found in the Metaverse
          </h1>
          
          <p style={{ 
            fontSize: '1.2rem', 
            color: 'var(--text-secondary)', 
            maxWidth: '600px', 
            margin: '0 auto 3rem',
            lineHeight: '1.6'
          }}>
            The decentralized page you're looking for has either been moved, 
            doesn't exist, or is on a different blockchain. Don't worry—even 
            in Web3, sometimes we take wrong turns.
          </p>

          {/* Main Actions */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '1.5rem', 
            marginBottom: '3rem',
            flexWrap: 'wrap'
          }}>
            <button 
              onClick={() => navigate('/')}
              className="btn btn-gold"
              style={{ 
                padding: '1rem 2.5rem', 
                fontSize: '1.1rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}
            >
              <FontAwesomeIcon icon={faHome} />
              Return to Home
            </button>
            
            <button 
              onClick={() => window.history.back()}
              className="btn"
              style={{ 
                padding: '1rem 2.5rem', 
                fontSize: '1.1rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                background: 'var(--card-bg)',
                color: 'var(--text-light)',
                border: '1px solid var(--gold)'
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              Go Back
            </button>
          </div>

          {/* Alternative Destinations */}
          <div style={{ 
            background: 'linear-gradient(135deg, var(--card-bg) 0%, rgba(0,0,0,0.3) 100%)', 
            borderRadius: '15px', 
            padding: '2.5rem',
            border: '1px solid var(--border)',
            marginTop: '2rem'
          }}>
            <h3 style={{ 
              color: 'var(--gold)', 
              fontSize: '1.5rem', 
              marginBottom: '1.5rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              justifyContent: 'center'
            }}>
              <FontAwesomeIcon icon={faSearch} />
              Explore Our Web3 Ecosystem
            </h3>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '1.5rem',
              marginBottom: '1.5rem'
            }}>
              <a 
                href="https://zpost.ai" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  background: 'rgba(255,215,0,0.05)', 
                  padding: '1.5rem', 
                  borderRadius: '10px',
                  border: '1px solid var(--gold)',
                  textDecoration: 'none',
                  color: 'var(--text-light)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px var(--gold-shadow)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ 
                  fontSize: '2rem', 
                  color: 'var(--gold)', 
                  marginBottom: '0.75rem' 
                }}>
                  Z
                </div>
                <h4 style={{ margin: '0 0 0.5rem 0', color: 'var(--text-light)' }}>Zpost.ai</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                  Decentralized social media with .zpost.eth identity
                </p>
              </a>
              
              <a 
                href="https://banksystem.co" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  background: 'rgba(128,0,0,0.05)', 
                  padding: '1.5rem', 
                  borderRadius: '10px',
                  border: '1px solid var(--dark-red)',
                  textDecoration: 'none',
                  color: 'var(--text-light)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(128,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ 
                  fontSize: '2rem', 
                  color: 'var(--dark-red)', 
                  marginBottom: '0.75rem' 
                }}>
                  B
                </div>
                <h4 style={{ margin: '0 0 0.5rem 0', color: 'var(--text-light)' }}>BankSystem.co</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                  DeFi banking with AI insights and .xbsys.eth domains
                </p>
              </a>
              
              <a 
                href="https://www.namecheap.com/domains/registration/results/?domain=yourname.myurl&hns=true" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  background: 'rgba(0,100,255,0.05)', 
                  padding: '1.5rem', 
                  borderRadius: '10px',
                  border: '1px solid #0064ff',
                  textDecoration: 'none',
                  color: 'var(--text-light)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,100,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ 
                  fontSize: '2rem', 
                  color: '#0064ff', 
                  marginBottom: '0.75rem' 
                }}>
                  <FontAwesomeIcon icon={faGlobe} />
                </div>
                <h4 style={{ margin: '0 0 0.5rem 0', color: 'var(--text-light)' }}>.MyUrl Domains</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', margin: 0 }}>
                  Web3 top-level domains via Handshake Protocol
                </p>
              </a>
            </div>
            
            <p style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.9rem', 
              textAlign: 'center',
              marginTop: '1.5rem',
              fontStyle: 'italic'
            }}>
              If you believe this page should exist, check our smart contract for updates.
            </p>
          </div>

          {/* Blockchain Animation */}
          <div style={{ 
            marginTop: '3rem', 
            paddingTop: '2rem', 
            borderTop: '1px solid var(--border)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ 
              position: 'absolute',
              top: '50%',
              left: '-100%',
              width: '200%',
              height: '2px',
              background: 'linear-gradient(90deg, transparent, var(--gold), transparent)',
              animation: 'blockchainFlow 4s linear infinite'
            }}></div>
            <p style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.9rem', 
              textAlign: 'center',
              position: 'relative',
              zIndex: 1,
              background: 'var(--black)',
              padding: '0 1rem',
              display: 'inline-block'
            }}>
              Blockchain Transaction Pending...
            </p>
          </div>
        </div>
      </section>

      <Footer />

      {/* CSS Animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes blockchainFlow {
          0% { transform: translateX(0); }
          100% { transform: translateX(50%); }
        }
        
        .landing-page .hero {
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

export default NotFound;
